import React from "react";

function Vida() {
  return (
    <div className="home">
      <iframe
        title="Vida"
        class="video"
        widht="100%"
        height="100%"
        src="#"
        marginheight="0"
        marginwidth="0"
        scrolling="0"
        frameborder="0"
        allowFullScreen="true"
      ></iframe>
    </div>
  );
}

export default Vida;
